import React from "react";
import classes from "./Container.module.css";
export default function Container(props) {
  return (
    <div style={props.style} className={`${classes.container}`}>
      {props.children}
    </div>
  );
}
